import type { AdapterStatus, AdapterStatusState } from "@/features/adapters/model/types";
import { getResourceDefinitions } from "./definitions";
import { getAdapterRecord } from "@/features/adapters/model/helpers";
import { createResourceIdResolver, getOwnedResource } from "./ownership";
import { getResourceDriver } from "./registry";
import type { ResourceInspection, ResourceRuntimeContext } from "./types";

export const inspectResources = (context: ResourceRuntimeContext): ResourceInspection[] => {
  const ownedResources = getAdapterRecord(context.release, context.definition)?.ownedResources;
  const driverContext = {
    ...context,
    resolveResourceId: createResourceIdResolver(context.definition, ownedResources),
  };
  return getResourceDefinitions(context).map((definition) =>
    getResourceDriver(definition).inspect(
      driverContext,
      definition,
      getOwnedResource(ownedResources, definition.stepId, definition.definitionKey)?.resourceId,
    ),
  );
};

export const worstResourceState = (states: AdapterStatusState[]): AdapterStatusState => {
  if (states.includes("error")) return "error";
  if (states.includes("conflict")) return "conflict";
  if (states.includes("missing")) return "missing";
  if (states.includes("incomplete")) return "incomplete";
  return "ready";
};

export const buildAdapterStatusFromResources = (
  adapterId: string,
  inspections: ResourceInspection[],
): AdapterStatus => {
  const applicable = inspections.filter((inspection) => inspection.applicable);
  return {
    adapterId,
    state: worstResourceState(applicable.map((inspection) => inspection.state)),
    components: applicable.map((inspection) => ({
      key: inspection.key,
      label: inspection.label,
      state: inspection.state,
      message: inspection.message,
      linkTo: inspection.href,
      linkLabel: inspection.linkLabel,
    })),
  };
};
